import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { HTTP_HEADER_NOT_LOADING } from '../constants/app.constant';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private spinner: NgxSpinnerService) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    if (this.requests.length <= 0) {
      this.spinner.hide();
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const notShowLoading =
      String(req.headers.get(HTTP_HEADER_NOT_LOADING)).toLowerCase() === 'true';

    var newReq = req.clone({
      headers: req.headers.delete(HTTP_HEADER_NOT_LOADING),
    });

    if (!notShowLoading) {
      this.requests.push(req);
      // console.log('No of requests--->' + this.requests.length);

      this.spinner.show();
    }

    return Observable.create((observer: any) => {
      const subscription = next.handle(newReq).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        (err) => {
          // alert('error' + err);
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
